import { useEffect, useState } from "react";
import "./MyInvitesSection.css";
import { API_BASE_URL } from "../utils";
import axios from "axios";
import MybookingCardSkeleton from "./customComp/MybookingCardSkeleton";
import CarnivalBookingCard from "./customComp/CarnivalBookingCard";
import { useGeoLocation } from "../context/LocationContext";


const dummyData = {


  "orderId": "#ZOM12345",
  "status": "Booking Confirmed",
  "eventImage": "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjh8fGV2ZW50fGVufDB8fDB8fHww",
  "clubImage": "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mjh8fGV2ZW50fGVufDB8fDB8fHww",
  "eventTitle": "Sitar Magic by Rishabh Rikhiram Sharma - Gurugramod Party",
  "category": "Carnival",
  "artist": "Malvika Khanna",
  "clubName": "F-Bar",
  "rating": 4.1,
  "reviews": 3,
  "address": "DLP Phase 3, Gurugram - 122010",
  "distance": "1.2 Kms",
  "eventType": "Stand-up Comedy",
  "date": "April 14, 2025 Mon",
  "time": "07:00 AM",
  "tickets": 3,
  "amountPaid": 1800



};



export default function MyCarnival() {

  const {latitude, longitude} = useGeoLocation();
  const [invitePending, setInvitePending] = useState([]);
  const [inviteComplete, setInviteComplete] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const userdata = JSON.parse(localStorage.getItem("userData"));

  const fetchInviteData = async (type, setter) => {
    const formData = new FormData();
    formData.append("user_id", userdata.id);
    formData.append("type", type);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/master/APIs/Carnival/bookingHistory`,
        formData
      );

      if (response.data?.status) {
        const data = response.data.data;

        if (Array.isArray(data)) {
          setter(data);
        } else if (data) {
          setter([data]);
        } else {
          setter([]);
        }
      } else {
        setter([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setter([]);
    }
  };

  useEffect(() => {
    async function load() {
      setIsLoading(true);
      await Promise.all([
        fetchInviteData("upcoming", setInvitePending, latitude, longitude),
        fetchInviteData("completed", setInviteComplete, latitude, longitude),
      ]);
      setIsLoading(false);
    }
    load();
  }, []);

  console.log("invitePending", invitePending);
  console.log("inviteComplete", inviteComplete);



  const renderEmpty = (text = "No Party is active for you.") => (
    <div className="mbpswc-content-temp">
      <h2>{text}</h2>
    </div>
  );

  const renderSkeletons = (count = 2) =>
    Array.from({ length: count }).map((_, i) => (
      <MybookingCardSkeleton key={`s-${i}`} />
    ));

  return (
    <div className="miv-card-container-section">
      {/* Pending Section */}
      <div className="invite-section">
        <h3 className="mbpswc-content-title">Upcoming</h3>
        {isLoading ? (
          renderSkeletons()
        ) : invitePending.length > 0 ? (
          invitePending.map((invite, index) => (
            <CarnivalBookingCard key={invite.id} booking={invite} />
          ))
        ) : (
          renderEmpty("No upcoming carnival found.")
        )}
      </div>

      {/* Complete Section */}
      <div className="invite-section">
        <h3 className="mbpswc-content-title">History</h3>
        {isLoading ? (
          renderSkeletons()
        ) : inviteComplete.length > 0 ? (
          inviteComplete.map((invite, index) => (
            <CarnivalBookingCard key={invite.id} booking={invite} isCompleted={true} />
          ))
        ) : (
          renderEmpty("No past carnival found.")
        )}
      </div>
    </div>
  );
}
